import React, { useLayoutEffect, useRef } from 'react'

// Summa yoziladigan maydon: yozayotganda raqamlar minglik ajratgich (probel) bilan
// ko'rinadi -- 10 000, 1 250 000. Adashmaslik uchun.
//
// Tashqariga esa HAR DOIM toza qiymat beriladi (probelsiz: "10000"), shuning uchun
// sahifalardagi mavjud onChange funksiyalari o'zgarishsiz ishlayveradi.

const NUMERIC = /[\d.,-]/

// "10000.5" -> "10 000.5". Yozib bo'lmagan holatlar ham saqlanadi ("10000." kabi).
export function groupDigits(raw) {
	if (raw === null || raw === undefined) return ''

	const value = String(raw)
	if (value === '') return ''

	const negative = value.startsWith('-')
	const body = negative ? value.slice(1) : value

	const dotIndex = body.indexOf('.')
	const intPart = dotIndex === -1 ? body : body.slice(0, dotIndex)
	const decimals = dotIndex === -1 ? '' : body.slice(dotIndex)

	const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

	return (negative ? '-' : '') + grouped + decimals
}

// Kursor o'rnini saqlash uchun: undan oldingi raqamlar soni.
function countDigitsBefore(text, position) {
	let count = 0
	for (let i = 0; i < position && i < text.length; i++) {
		if (NUMERIC.test(text[i])) count++
	}
	return count
}

// Aksincha: shuncha raqamdan keyingi o'rin.
function positionAfterDigits(text, digitCount) {
	if (digitCount <= 0) return 0

	let count = 0
	for (let i = 0; i < text.length; i++) {
		if (NUMERIC.test(text[i])) count++
		if (count === digitCount) return i + 1
	}

	return text.length
}

function MoneyInput({ value, onChange, name, ...rest }) {
	const inputRef = useRef(null)
	const caretDigitsRef = useRef(null)

	const displayValue = groupDigits(value)

	// Probel qo'shilgach kursor oxiriga sakrab ketmasligi uchun o'rnini tiklaymiz.
	useLayoutEffect(() => {
		if (caretDigitsRef.current === null || !inputRef.current) return

		const position = positionAfterDigits(displayValue, caretDigitsRef.current)
		caretDigitsRef.current = null

		try {
			inputRef.current.setSelectionRange(position, position)
		} catch (error) {
			// Ba'zi brauzerlarda fokus yo'q bo'lsa xato beradi -- muhim emas.
		}
	})

	function handleChange(event) {
		const element = event.target
		const typed = element.value
		const caret = element.selectionStart === null || element.selectionStart === undefined
			? typed.length
			: element.selectionStart

		caretDigitsRef.current = countDigitsBefore(typed, caret)

		const raw = typed.replace(/\s/g, '')

		onChange({
			target: { name: name === undefined ? element.name : name, value: raw },
			preventDefault: () => event.preventDefault(),
			stopPropagation: () => event.stopPropagation(),
		})
	}

	return (
		<input
			{...rest}
			ref={inputRef}
			name={name}
			type="text"
			inputMode="decimal"
			value={displayValue}
			onChange={handleChange}
		/>
	)
}

export default MoneyInput
